module.exports = __webpack_public_path__ + "static/media/diary.ba5484e0.jpg";